<template>
  <div id='transactionList'>
    <router-view></router-view>
    <div v-show="$route.meta.keepAlive">
      <div class="content-title">
        <Icon type="android-settings"></Icon>派車單統計
        <div class="border"></div>
      </div>
      <Row>
        <Col span="12">
          <Select v-model="year" style="width:70px" @on-query-change="getTransactionList">
            <Option v-for="y in yearList" :value="y" :key="y">{{ y }}</Option>
          </Select>
          年
          <Select v-model="month" style="width:50px" @on-query-change="getTransactionList">
            <Option v-for="m in monthList" :value="m" :key="m">{{ m }}</Option>
          </Select>
          月
        </Col>
        <Col span="6" style="text-align: right; font-size: 20px">
          搜尋關鍵字　
        </Col>
        <Col span="6">
          <Input v-model="kw" @on-change="search"></Input>
        </Col>
      </Row>

      <Table border :columns="column" :data="viewData"></Table>
    </div>
  </div>
</template>

<script>
import { API } from "@/assets/config";

export default {
  name: "transactionList",
  data() {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      yearList: [2015],
      monthList: [1,2,3,4,5,6,7,8,9,10,11,12],
      kw:"",
      name: "",
      column: [
        { title: '客戶名稱', key: 'name' },
        { title: '轉出', key: 'transferOut' },
        { title: '轉入', key: 'transferIn' },
        { title: '正常單', key: 'normal' },
        { 
          title: '檢視', 
          key: 'review',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    console.log(params)
                    this.show(params.index)
                  }
                }
              }, '檢視')
            ]);
          } 
        }
      ],
      data: [],
      viewData: []
      
    };
  },
  async created() {
    this.initYearMonth()
    try {
      await this.getTransactionList()
    } catch (error) {
      this.errorHandle(error)
    }
  },
  methods: {
    initYearMonth() {
      let now = new Date()
      let year = now.getFullYear()
      let month = now.getMonth() + 1
      while(this.yearList[this.yearList.length - 1] < year) {
        this.yearList.push(this.yearList[this.yearList.length - 1] + 1)
      }
    },
    async getTransactionList() {
      let res = await this.axios.get(API.transactions + `?date=${this.year}-${this.month}-1`)
      console.log(res)
      this.data = res.data
      this.viewData = res.data
    },
    search() {
      this.viewData = this.data.filter( d => {
        return d.name.indexOf(this.kw) !== -1
      })
    },
    show (tableIndex) {
      console.log(tableIndex)
      let id = this.viewData[tableIndex].id
      this.name = this.viewData[tableIndex].name
      this.$router.push({name: 'transaction', params: { id}})
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ivu-row {
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/transaction/transactionList.vue